import { useCallback, useState } from 'react';

import { BLOCK_SCENES } from './config';
import { BlockSceneValues } from './types';

export function useChangingScene() {
  const [scene, setScene] = useState<BlockSceneValues>(BLOCK_SCENES.DEFAULT);
  const handleChangeScene = useCallback((newScene: BlockSceneValues) => {
    setScene(newScene);
  }, []);

  return {
    scene,
    handleChangeScene,
  };
}
